// extracted by mini-css-extract-plugin
module.exports = {"list":"Policy_list_36Buk","label":"Policy_label_2zvOt"};